type TypedField = { type?: string; value?: unknown } | undefined

/** Same suffix as applyListboxWireTypesFromListboxFields (`{name}__listbox`). */
const LISTBOX_FIELD_SUFFIX = '__listbox'

function isScalarBooleanField(field: TypedField): field is { type: 'Boolean'; value: unknown } {
  if (!field || typeof field !== 'object' || field.type !== 'Boolean') {
    return false
  }
  const value = field.value
  return typeof value === 'boolean' || value === null || value === undefined
}

function booleanToFlowContextString(value: unknown): 'true' | 'false' {
  return value === true ? 'true' : 'false'
}

function hasListboxSibling(fields: Record<string, TypedField>, key: string): boolean {
  return `${key}${LISTBOX_FIELD_SUFFIX}` in fields
}

/**
 * ListBox Boolean (has `{name}__listbox`) → String "true"/"false" for flow ctx.
 * Script scalars (`setField(..., true)`) stay Boolean so `ctx.get(name) == true` works.
 */
export function normalizePlatformFlowContextFields(fields: Record<string, TypedField>): void {
  if (!fields || typeof fields !== 'object') {
    return
  }

  for (const [key, field] of Object.entries(fields)) {
    if (!isScalarBooleanField(field) || !hasListboxSibling(fields, key)) {
      continue
    }
    fields[key] = {
      type: 'String',
      value: booleanToFlowContextString(field.value),
    }
  }
}

/** Applies normalizePlatformFlowContextFields to ExchangeData-shaped currentData. */
export function normalizePlatformFlowContextCurrentData(currentData: unknown): void {
  if (!currentData || typeof currentData !== 'object') {
    return
  }
  const fieldsLevel1 = (currentData as { fields?: unknown }).fields
  if (!fieldsLevel1 || typeof fieldsLevel1 !== 'object') {
    return
  }
  const fieldsLevel2 = (fieldsLevel1 as { fields?: Record<string, TypedField> }).fields
  if (!fieldsLevel2 || typeof fieldsLevel2 !== 'object') {
    return
  }
  normalizePlatformFlowContextFields(fieldsLevel2)
}
